const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		// GET
		case "FAQ_ARE_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "FAQ_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "FAQ_SUCCESS":
			return {
				...state,
				faq: action.data,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/faq.js